import React from 'react'

const Commission = () => {
  return (
    <div>Commission</div>
  )
}

export default Commission